'use client';

import { CloseIcon } from '@/assets';
import { useModalStore } from '@/store';

export const Modal = ({ children }: { children: React.ReactNode }) => {
  const { isOpen, closeModal } = useModalStore();

  return (
    <div
      className={`z-50 w-full fixed inset-0 flex items-center justify-center bg-black/65 backdrop-blur-lg transform transition-all duration-700 ${
        isOpen
          ? 'visible opacity-100 translate-y-0'
          : 'invisible opacity-0 -translate-y-full'
      }`}
    >
      <div className="p-6 w-full relative h-full overflow-y-auto no-scrollbar">
        <button
          className="absolute top-4 right-4 bg-white bg-opacity-20 rounded-full p-2 hover:bg-opacity-30"
          onClick={closeModal}
        >
          <CloseIcon width={24} height={24} />
        </button>
        {children}
      </div>
    </div>
  );
};
